import { render, staticRenderFns } from "./PasajerosCount.vue?vue&type=template&id=2a77295c&scoped=true&"
import script from "./PasajerosCount.vue?vue&type=script&lang=js&"
export * from "./PasajerosCount.vue?vue&type=script&lang=js&"
import style0 from "./PasajerosCount.vue?vue&type=style&index=0&id=2a77295c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77295c",
  null
  
)

export default component.exports